import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail',
  standalone: true,
})
export class MaskEmailPipe implements PipeTransform {
  transform(email: string): string {
    if (!email) return '';

    const [username, domain] = email.split('@');
    if (!username || !domain) return email;

    if (username.length <= 2) {
      return username[0] + '*'.repeat(username.length - 1) + '@' + domain;
    }

    const firstChar = username[0];
    const lastChar = username[username.length - 1];
    const masked = firstChar + '*'.repeat(username.length - 2) + lastChar;

    return masked + '@' + domain;
  }
}
